import { useState, useEffect } from 'react';
import {
  useSelector,
} from 'react-redux';
import { Grid, Button } from '@material-ui/core';
import CustomerTree from '../common/customerTree/customerTree';

export default function CustomerTreeSelectTest() {
  // isSpを取得したい場合は下記一行をコピペでOK
  const isSp = useSelector((state) => state.deviceTypeSlice.isSp);

  // ツリー表示/非表示
  const [isOpen, setIsOpen] = useState(false);
  // 反響ツリー選択ユーザー
  const [selectUser, setSelectUser] = useState({ userId: 0, userName: '' });
  // 反響ツリー選択組織
  const [selectDivision, setSelectDivision] = useState({ divId: 0, divisionName: '' });
  // 反響ツリー選択顧客
  const [selectCustomer, setSelectCustomer] = useState([]);
  // Dialog形式かどうか
  const [isModal, setIsModal] = useState(true);
  // 検索ボックスの表示/非表示
  const [searchForm, setSearchForm] = useState(true);
  // 検索と選択対象
  const [targetFlgList] = useState({
    userFlg: true,
    divisionFlg: true,
    customerFlg: true,
  });

  useEffect(() => {
    console.log('---------反響ツリー取得内容-------');
    console.log('selectUser----');
    console.log(selectUser);
    console.log('selectDivision----');
    console.log(selectDivision);
    console.log('selectCustomer----');
    console.log(selectCustomer);
    console.log(isModal);
    console.log(isOpen);
  }, [selectUser, selectDivision, selectCustomer]);

  const onCheck = () => {
    console.log('selectUser----');
    console.log(selectUser);
    console.log('selectDivision----');
    console.log(selectDivision);
    console.log('selectCustomer----');
    console.log(selectCustomer);
  };

  return (
    <Grid container>
      <Grid item xs={3} md={3} lg={3} xl={3}>
        <CustomerTree
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setSelectUser={setSelectUser}
          setSelectDivision={setSelectDivision}
          setSelectCustomer={setSelectCustomer}
          isMulti
          targetFlgList={targetFlgList}
          defaultUserId={selectUser?.userId}
          // eslint-disable-next-line no-mixed-operators
          defaultDivisionId={selectDivision?.divId && !selectUser?.userId || selectDivision?.divId && selectUser?.userId === -1 ? selectDivision.divId : ''}
        />
      </Grid>
      <Grid item xs={1} md={1} lg={1} xl={1} />
      <Grid item xs={3} md={3} lg={3} xl={3}>
        <Button
          style={{ backgroundColor: 'lightSkyBlue', color: 'white' }}
          onClick={() => {
            setIsModal(true);
            setIsOpen(true);
          }}
        >
          ダイアログ
        </Button>
        {!isSp && (
          <Button
            style={{ backgroundColor: 'lightSkyBlue', color: 'white', marginLeft: '10px' }}
            onClick={() => {
              setSearchForm(!searchForm);
            }}
          >
            検索表示切り替え
          </Button>
        )}
      </Grid>
      <Button onClick={() => onCheck()}>Check</Button>
    </Grid>
  );
}
